import axios from "axios";
import { newLeadsAction } from "./NewLeadsAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

const getAdminURL = (state) => state.environnment.environmentLists.adminBaseURL;
const getBaseEndpoint = (state) =>
  `${process.env.REACT_APP_HOST}${getAdminURL(state)}/newLeadsCalling`;

export const getAllNewLeadsAsync = (searchBy, searchText, audioType = "all", batchFilter = "", fromDateFilter = "", toDateFilter = "", leadType = "all", createdByFilter = "", sortColumn = "createdOn", sortDirection = "desc", callOutcomeStatus = "", companyNameFilter = "all") => {
  return async (dispatch, getState) => {
    try {
      const { skip, limit } = getState().newDataCall;
      const { user } = getState().auth;
      dispatch(newLeadsAction.getAllNewLeadsStart());
      
      // Build query parameters
      // Use searchBy as column if provided, otherwise use sortColumn (default: createdOn)
      const column = searchBy || sortColumn;
      // Use sortDirection (default: desc)
      const dir = sortDirection || "desc";
      
      let url = `${getBaseEndpoint(getState())}/getAll?skip=${skip}&limit=${limit}&column=${column}&dir=${dir}&search=${encodeURIComponent(searchText || "")}&audio_type=${audioType}`;
      
      // Add batch filter if provided
      if (batchFilter) {
        url += `&batch_name=${encodeURIComponent(batchFilter)}`;
      }
      
      // Add from date filter if provided (format: DD/MM/YYYY)
      if (fromDateFilter) {
        url += `&from_date=${encodeURIComponent(fromDateFilter)}`;
      }
      
      // Add to date filter if provided (format: DD/MM/YYYY)
      if (toDateFilter) {
        url += `&to_date=${encodeURIComponent(toDateFilter)}`;
      }
      
      // Add lead type filter if provided and not "all"
      if (leadType && leadType !== "all") {
        url += `&lead_type=${encodeURIComponent(leadType)}`;
      }
      
      // Add created by filter if provided
      let createdByParamValue = createdByFilter;
      // Non-admin users should always only see their own leads regardless of chosen filter
      // eslint-disable-next-line eqeqeq
      if (user && user._id && user.roleId != 1 && user.email != "himanshu.soni@webcluesinfotech.com") {
        createdByParamValue = user._id;
      }
      if (createdByParamValue) {
        url += `&created_by=${encodeURIComponent(createdByParamValue)}`;
      }
      
      if (callOutcomeStatus && callOutcomeStatus !== "all") {
        url += `&call_outcome_status=${encodeURIComponent(callOutcomeStatus)}`;
      }

      if (companyNameFilter && companyNameFilter !== "all") {
        url += `&company_name=${encodeURIComponent(companyNameFilter)}`;
      }
      
      const { data } = await axios({
        method: "GET",
        url,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data?.code === 200) {
        dispatch(newLeadsAction.getAllNewLeadsSuccess(data.data));
      } else {
        dispatch(newLeadsAction.getAllNewLeadsError());
        dispatch(
          showSuccessSnackbar(
            "error",
            data?.message || "Failed to fetch new data calls",
            3000
          )
        );
      }
    } catch (error) {
      console.error("Failed to fetch new data calls", error);
      dispatch(newLeadsAction.getAllNewLeadsError());
      dispatch(showSuccessSnackbar("error", "Error while fetching new data calls", 3000));
    }
  };
};

// View single lead - Backend handles permission check:
// Super Admin (roleId == 1): Can view any lead
// Sales Team: Can only view their own leads (created_by = req._id)
export const getNewLeadAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch(newLeadsAction.getNewLeadStart());
      const { data } = await axios({
        method: "GET",
        url: `${getBaseEndpoint(getState())}/getCallDetails/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data?.code === 200) {
        const payload = data.data || {};
        // Extract lead from the response structure: { lead: {...}, call_ai: [...] }
        const leadData = payload.lead || payload;
        dispatch(newLeadsAction.getNewLeadSuccess(leadData));
      } else {
        dispatch(newLeadsAction.getNewLeadError());
        dispatch(
          showSuccessSnackbar(
            "error",
            data?.message || "Failed to fetch new data call",
            3000
          )
        );
      }
    } catch (error) {
      console.error("Failed to fetch new data call", error);
      dispatch(newLeadsAction.getNewLeadError());
      dispatch(showSuccessSnackbar("error", "Error while fetching new data call", 3000));
    }
  };
};

// Delete single lead - Backend handles permission check:
// Super Admin (roleId == 1): Can delete any lead
// Sales Team: Can only delete their own leads (created_by = req._id)
export const deleteNewLeadAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(newLeadsAction.getNewLeadStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/newLeadsCalling/removeMultiNewLeadsCalling`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          data: [id],
        },
      });
      if (data?.code === 200) {
        dispatch(
          showSuccessSnackbar("success", data?.message || "Lead deleted successfully", 3000)
        );
        dispatch(newLeadsAction.getNewLeadSuccess({}));
      } else {
        dispatch(newLeadsAction.getNewLeadError());
        dispatch(
          showSuccessSnackbar(
            "error",
            data?.message || "Failed to delete lead",
            3000
          )
        );
      }
    } catch (error) {
      console.error("Failed to delete new data call", error);
      dispatch(newLeadsAction.getNewLeadError());
      dispatch(showSuccessSnackbar("error", "Error while deleting lead", 3000));
    }
  };
};

// Delete multiple leads - Backend handles permission check:
// Super Admin (roleId == 1): Can delete any leads
// Sales Team: Can only delete their own leads (created_by = req._id)
export const deleteSelectedNewLeadsAsync = (ids) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(newLeadsAction.getNewLeadStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/newLeadsCalling/deletedSelectedNewLeadsCalling`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          ids,
        },
      });
      if (data?.code === 200) {
        dispatch(
          showSuccessSnackbar(
            "success",
            data?.message || "Selected leads deleted successfully",
            3000
          )
        );
        dispatch(newLeadsAction.getNewLeadSuccess({}));
      } else {
        dispatch(newLeadsAction.getNewLeadError());
        dispatch(
          showSuccessSnackbar(
            "error",
            data?.message || "Failed to delete selected leads",
            3000
          )
        );
      }
    } catch (error) {
      console.error("Failed to delete selected new data calls", error);
      dispatch(newLeadsAction.getNewLeadError());
      dispatch(showSuccessSnackbar("error", "Error while deleting selected leads", 3000));
    }
  };
};

export const importNewLeadsAsync = (file) => {
  return async (dispatch, getState) => {
    if (!file) {
      dispatch(showSuccessSnackbar("error", "Please select a file to import.", 3000));
      return { success: false, error: "No file selected" };
    }

    try {
      const { companyNameFilter } = getState().newDataCall || {};
      if (!companyNameFilter || companyNameFilter === "all") {
        dispatch(
          showSuccessSnackbar(
            "error",
            "Please select Webclues or Codezeros in the All Companies dropdown before importing data.",
            5000
          )
        );
        return { success: false, error: "Company not selected" };
      }
      const companyNameLabel = companyNameFilter === "webclues" ? "Webclues" : "Codezeros";

      const formData = new FormData();
      formData.append("file", file);
      formData.append("CompanyName", companyNameLabel);

      const response = await axios({
        method: "POST",
        url: `${getBaseEndpoint(getState())}/import`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });

      const payload = response?.response?.data ?? response?.data;
      const isRequestError = Boolean(response?.isAxiosError || response?.response);

      if (!isRequestError && payload?.code === 200 && payload?.status === true) {
        const importData = payload.data || {};
        const message = payload.message || "New data calls imported successfully.";
        dispatch(showSuccessSnackbar("success", message, 5000));
        return { success: true, data: importData };
      }

      const apiErrorMessage =
        (typeof payload?.message === "string" && payload.message.trim()) || "";
      const errorMessage = apiErrorMessage || "Failed to import new data calls";

      dispatch(showSuccessSnackbar("error", errorMessage, 5000));
      return { success: false, error: errorMessage, details: payload?.data || null };
    } catch (error) {
      console.error("Failed to import new data calls", error);
      const apiErrorMessage =
        (typeof error?.response?.data?.message === "string" &&
          error.response.data.message.trim()) ||
        "";
      const errorMessage =
        apiErrorMessage || error?.message || "Error while importing new data calls";
      dispatch(showSuccessSnackbar("error", errorMessage, 5000));
      return { success: false, error: errorMessage, details: error?.response?.data?.data || null };
    }
  };
};

// Initiate call for a lead - Backend handles permission check:
// Super Admin (roleId == 1): Can call any lead
// Sales Team: Can only call their own leads (created_by = req._id)
export const startNewLeadCallAsync = (leadId) => {
  return async (dispatch, getState) => {
    if (!leadId) {
      dispatch(showSuccessSnackbar("error", "Lead ID is required to start a call.", 3000));
      return { success: false, error: "Lead ID is required" };
    }

    try {
      const { data } = await axios({
        method: "POST",
        url: `${getBaseEndpoint(getState())}/initiateCall/${leadId}`,
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (data?.code === 200 && data?.status === true) {
        dispatch(
          showSuccessSnackbar(
            "success",
            data?.message || "Call initiated successfully",
            3000
          )
        );
        return { success: true, data: data.data };
      } else {
        dispatch(
          showSuccessSnackbar(
            "error",
            data?.message || "Failed to initiate call",
            3000
          )
        );
        return { success: false, error: data?.message || "Failed to initiate call" };
      }
    } catch (error) {
      console.error("Failed to initiate new data call", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Error while initiating call";
      dispatch(showSuccessSnackbar("error", errorMessage, 3000));
      return { success: false, error: errorMessage };
    }
  };
};

// Bulk call multiple leads - Backend handles permission check:
// Super Admin (roleId == 1): Can call any leads
// Sales Team: Can only call their own leads (created_by = req._id)
export const bulkCallNewLeadsAsync = (leadIds) => {
  return async (dispatch, getState) => {
    if (!leadIds || leadIds.length === 0) {
      dispatch(showSuccessSnackbar("error", "Please select at least one lead to call.", 3000));
      return { success: false, error: "No leads selected" };
    }

    try {
      const { data } = await axios({
        method: "POST",
        url: `${getBaseEndpoint(getState())}/bulkCall`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          leadIds,
        },
      });

      if (data?.code === 200 && data?.status === true) {
        dispatch(
          showSuccessSnackbar(
            "success",
            data?.message || "Bulk calls initiated successfully",
            5000
          )
        );
        return { success: true, data: data.data };
      } else {
        dispatch(
          showSuccessSnackbar(
            "error",
            data?.message || "Failed to initiate bulk calls",
            3000
          )
        );
        return { success: false, error: data?.message || "Failed to initiate bulk calls" };
      }
    } catch (error) {
      console.error("Failed to initiate bulk new data calls", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Error while initiating bulk calls";
      dispatch(showSuccessSnackbar("error", errorMessage, 3000));
      return { success: false, error: errorMessage };
    }
  };
};

export const getBatchNamesAsync = () => {
  return async (dispatch, getState) => {
    try {
      const { user } = getState().auth;
      const createdByFilter = getState().newDataCall?.createdByFilter ?? "";

      let url = `${getBaseEndpoint(getState())}/getBatchNames`;

      const queryParts = [];
      // eslint-disable-next-line eqeqeq
      const isElevated =
        user &&
        (user.roleId == 1 ||
          String(user.email || "")
            .trim()
            .toLowerCase() === "himanshu.soni@webcluesinfotech.com");

      // Sales (non-admin): only their own batches
      // Elevated (Super Admin / himanshu): batches filtered by the selected "All Created By" user,
      //   or "all" when no specific user is chosen.
      // eslint-disable-next-line eqeqeq
      if (user && user._id && user.roleId != 1 && user.email != "himanshu.soni@webcluesinfotech.com") {
        queryParts.push(`created_by=${encodeURIComponent(user._id)}`);
      } else if (isElevated) {
        const v =
          createdByFilter && typeof createdByFilter === "object" && createdByFilter._id != null
            ? String(createdByFilter._id).trim()
            : String(createdByFilter || "").trim();
        queryParts.push(`created_by=${encodeURIComponent(v || "all")}`);
      }

      if (queryParts.length) {
        url += `?${queryParts.join("&")}`;
      }
      
      const { data } = await axios({
        method: "GET",
        url,
        headers: {
          "Content-Type": "application/json",
        },
      });
      
      if (data?.code === 200) {
        // Handle response structure: { data: { batchNames: [...], total: number } }
        let batchData = [];
        
        if (data.data) {
          // Structure 1: { data: { batchNames: [...] } } - Most common
          if (data.data.batchNames && Array.isArray(data.data.batchNames)) {
            batchData = data.data.batchNames;
          }
          // Structure 2: { data: [...] } - data.data is the array itself
          else if (Array.isArray(data.data)) {
            batchData = data.data;
          }
          // Structure 3: If it's an object, try to extract array values
          else if (typeof data.data === 'object') {
            batchData = Object.values(data.data);
            // Filter to ensure we only have strings
            batchData = batchData.filter(item => typeof item === 'string');
          }
        }
        
        // Ensure we always return an array of string batch names (API may return { name } objects)
        if (!Array.isArray(batchData)) {
          batchData = [];
        } else {
          batchData = batchData
            .map((item) =>
              typeof item === "string"
                ? item
                : item && item.name != null
                ? String(item.name)
                : ""
            )
            .filter(Boolean);
        }
        
        return { success: true, data: batchData };
      } else {
        return { success: false, error: data?.message || "Failed to fetch batch names", data: [] };
      }
    } catch (error) {
      console.error("Failed to fetch new data call batch names", error);
      return { success: false, error: error?.message || "Error while fetching batch names", data: [] };
    }
  };
};

export const getCreatedByUsersAsync = () => {
  return async (dispatch, getState) => {
    try {
      const url = `${getBaseEndpoint(getState())}/getCreatedByUsers`;
      const { data } = await axios({
        method: "GET",
        url,
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (data?.code === 200) {
        const users = Array.isArray(data.data) ? data.data : [];
        return { success: true, data: users };
      }
      return { success: false, error: data?.message || "Failed to fetch created by users", data: [] };
    } catch (error) {
      console.error("Failed to fetch new data call creators", error);
      return { success: false, error: error?.message || "Error while fetching created by users", data: [] };
    }
  };
};

export const downloadSampleExcelAsync = () => {
  return async (dispatch, getState) => {
    try {
      const response = await axios({
        method: "GET",
        url: `${getBaseEndpoint(getState())}/downloadSample`,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary URL and trigger download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "new_data_call_sample.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      dispatch(showSuccessSnackbar("success", "Sample file downloaded successfully", 3000));
      return { success: true };
    } catch (error) {
      console.error("Failed to download new data call sample file", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Error while downloading sample file";
      dispatch(showSuccessSnackbar("error", errorMessage, 3000));
      return { success: false, error: errorMessage };
    }
  };
};

// Update new data call - Backend handles permission check:
// Super Admin (roleId == 1): Can update any lead
// Sales Team: Can only update their own leads (created_by = req._id)
export const updateNewLeadAsync = (leadId, updateData) => {
  return async (dispatch, getState) => {
    if (!leadId) {
      dispatch(showSuccessSnackbar("error", "Lead ID is required to update.", 3000));
      return { success: false, error: "Lead ID is required" };
    }

    try {
      const response = await axios({
        method: "PUT",
        url: `${getBaseEndpoint(getState())}/update/${leadId}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: updateData,
      });

      const payload = response?.response?.data ?? response?.data;
      const isRequestError = Boolean(response?.isAxiosError || response?.response);

      if (!isRequestError && payload?.code === 200 && payload?.status === true) {
        dispatch(
          showSuccessSnackbar(
            "success",
            payload?.message || "Lead updated successfully",
            3000
          )
        );
        // Update the selected new data call in Redux state
        if (payload?.data) {
          dispatch(newLeadsAction.getNewLeadSuccess(payload.data));
        }
        return { success: true, data: payload?.data };
      } else {
        // Check if it's a duplicate contact number error
        const apiErrorMessage =
          (typeof payload?.message === "string" && payload.message.trim()) || "";
        const isDuplicate =
          apiErrorMessage.toLowerCase().includes("already exists") ||
          apiErrorMessage.toLowerCase().includes("duplicate");
        const errorMessage = apiErrorMessage || "Failed to update lead";
        dispatch(
          showSuccessSnackbar(
            "error",
            errorMessage,
            3000
          )
        );
        return {
          success: false,
          error: errorMessage,
          isDuplicate
        };
      }
    } catch (error) {
      console.error("Failed to update new data call", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Error while updating new data call";
      const isDuplicate = errorMessage?.toLowerCase().includes("already exists") || 
                         errorMessage?.toLowerCase().includes("duplicate");
      dispatch(showSuccessSnackbar("error", errorMessage, 3000));
      return { 
        success: false, 
        error: errorMessage,
        isDuplicate 
      };
    }
  };
};

// Update leadType - Backend handles permission check:
// Super Admin (roleId == 1): Can update any lead
// Sales Team: Can only update their own leads (created_by = req._id)
export const updateNewLeadTypeAsync = (leadId, leadType) => {
  return async (dispatch, getState) => {
    if (!leadId) {
      dispatch(showSuccessSnackbar("error", "Lead ID is required to update lead type.", 3000));
      return { success: false, error: "Lead ID is required" };
    }

    try {
      const { data } = await axios({
        method: "PUT",
        url: `${getBaseEndpoint(getState())}/getCallDetails/${leadId}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { leadType },
      });

      if (data?.code === 200 && data?.status === true) {
        dispatch(
          showSuccessSnackbar(
            "success",
            data?.message || "Lead type updated successfully",
            3000
          )
        );
        return { success: true, data: data.data };
      } else {
        dispatch(
          showSuccessSnackbar(
            "error",
            data?.message || "Failed to update lead type",
            3000
          )
        );
        return { 
          success: false, 
          error: data?.message || "Failed to update lead type"
        };
      }
    } catch (error) {
      console.error("Failed to update new data call lead type", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Error while updating lead type";
      dispatch(showSuccessSnackbar("error", errorMessage, 3000));
      return { 
        success: false, 
        error: errorMessage
      };
    }
  };
};

// Check if contact number already exists
// Backend handles permission check:
// Super Admin (roleId == 1): Can check any contact number
// Sales Team: Can only check contact numbers for their own leads
export const checkNewLeadContactNumberExistsAsync = (contactNumber, excludeId = null) => {
  return async (dispatch, getState) => {
    if (!contactNumber || contactNumber.trim() === "") {
      return { success: true, exists: false };
    }

    try {
      let url = `${getBaseEndpoint(getState())}/checkContactNumber`;
      
      // Add excludeId as query parameter if provided
      if (excludeId) {
        url += `?excludeId=${excludeId}`;
      }

      const { data } = await axios({
        method: "POST",
        url,
        headers: {
          "Content-Type": "application/json",
        },
        data: { contactNumber: contactNumber.trim() },
      });

      if (data?.code === 200) {
        const exists = data.data?.exists || false;
        return { 
          success: true, 
          exists,
          data: data.data 
        };
      } else {
        return { 
          success: false, 
          exists: false,
          error: data?.message || "Failed to check contact number" 
        };
      }
    } catch (error) {
      console.error("Failed to check new data call contact number", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Error while checking contact number";
      return { 
        success: false, 
        exists: false,
        error: errorMessage 
      };
    }
  };
};


